import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import useCustomTranslation from 'hooks/useCustomTranslation';
import { useFormikContext } from 'formik';
export default function SignupToggleButton({ alignment, onChange }) {
  const { t } = useCustomTranslation();
  const { setFieldValue } = useFormikContext();

  const handleAlignment = (event, newAlignment) => {
    onChange(newAlignment);
    // console.log(newAlignment)
    setFieldValue('role', newAlignment);
    // console.log(formik)
  };

  //make that into key value pair
  const options = [
    { key: 'company', value: t('Company') },
    { key: 'employee', value: t('Employee') },
  ];

  return (
    <ToggleButtonGroup
      color="primary"
      value={alignment}
      exclusive
      onChange={handleAlignment}
      aria-label="Platform"
    >
      {options.map((option) => (
        <ToggleButton key={option.key} value={option.key} aria-label={option.value}>
          {option.value}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
